/* tslint:disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration for Api services
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = 'https://adv-test.kubernetes-test.paragon-systems.de/advsortiment/v1';
}

export interface ApiConfigurationInterface {
  rootUrl?: string;
}
